
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/5ffe42c93a1e919f8abf70691c75413d.jpg')`
        }}
      ></div>
      
      {/* Content Container */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium mb-6">
              <i className="ri-graduation-cap-line mr-2"></i>
              财税大数据专业教育平台
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              智能化
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600">
                财税教育
              </span>
              新时代
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 max-w-2xl">
              通过可视化知识图谱、智能学习路径和大数据分析，
              为财税专业学生提供全方位的现代化学习体验，
              培养适应数字经济时代的高素质财税人才
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Link to="/courses">
                <Button size="lg" className="w-full sm:w-auto">
                  <i className="ri-book-open-line mr-2"></i>
                  查看课程
                </Button>
              </Link>
              <Button variant="outline" size="lg">
                <i className="ri-play-circle-line mr-2"></i>
                观看演示
              </Button>
            </div>
          </div>
          
          {/* Right Content - Feature Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-mind-map text-2xl text-blue-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">知识图谱</h3>
              <p className="text-gray-600 text-sm">可视化展示知识结构，清晰理解概念关联</p>
            </div>
            
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-route-line text-2xl text-green-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">学习路径</h3>
              <p className="text-gray-600 text-sm">个性化学习规划，循序渐进掌握技能</p>
            </div>
            
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-bar-chart-box-line text-2xl text-purple-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">数据分析</h3>
              <p className="text-gray-600 text-sm">智能分析学习数据，优化教学效果</p>
            </div>
            
            <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-robot-line text-2xl text-orange-600"></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">智能助手</h3>
              <p className="text-gray-600 text-sm">AI驱动的学习辅导，24小时在线答疑</p>
            </div>
          </div>
        </div>
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-20 h-20 bg-blue-200 rounded-full opacity-50 animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-32 h-32 bg-purple-200 rounded-full opacity-30 animate-pulse delay-1000"></div>
      <div className="absolute top-1/2 right-20 w-16 h-16 bg-green-200 rounded-full opacity-40 animate-pulse delay-500"></div>
    </section>
  );
}
